import script from "./AcceptAnyOddsToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptAnyOddsToggle.vue?vue&type=script&setup=true&lang=js"

import "./AcceptAnyOddsToggle.vue?vue&type=style&index=0&id=0a4756ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4756ba"]])

export default __exports__